import { TextBoxMaxLine1FontXlBold } from 'atoms/TextBox/Templates'
import {
  ChangeUsernamePasswordBlockSC,
  ContainerSC,
} from './ChangeUsernamePasswordBlock.styled'

interface ISettingsMenuProps {
  title?: string
  children: React.ReactNode
}

export const ChangeUsernamePasswordBlock = ({
  title,
  children,
}: ISettingsMenuProps) => {
  return (
    <ChangeUsernamePasswordBlockSC>
      {title && <TextBoxMaxLine1FontXlBold title={title} />}

      <ContainerSC>{children}</ContainerSC>
    </ChangeUsernamePasswordBlockSC>
  )
}
